import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from './../environments/environment';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { RouterModule } from '@angular/router';
import { routes } from './app.routing';
import { SafeHtml, AsyncIMG } from './pipes/index';
import { NotificationService } from './services/notification.service';
import { FireBaseService } from './services/firebase.service';
import { SlideShowComponent } from './components/slideshow/slideshow.component';
import { AnnouncerComponent } from './components/announcer/announcer.component';
import { QuoteComponent } from './components/quote/quote.component';
import { CeremonyComponent } from './ceremony/ceremony.component';
import { ParentNavDirective } from './directives/parentnav.directive';
import { SearchComponent } from './components/search/search.component';
import { ScrollableDirective } from './directives/scrollable.directive';
import { PaginationService } from './services/pagination.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CeremonyComponent,
    SlideShowComponent,
    AnnouncerComponent,
    QuoteComponent,
    SearchComponent,
    SafeHtml,
    AsyncIMG,
    ParentNavDirective,
    ScrollableDirective
  ],
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    FormsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFirestoreModule
  ],
  providers: [NotificationService, FireBaseService, PaginationService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts